import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../assets/CustomTableStyles";

function StudentAchievementRating() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [searchTerm, setSearchTerm] = useState("");

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
  } = useForm({
    defaultValues: {
      id: 0,
      name: "",
      createdBy: localStorage.getItem("userId"),
      organizationId: organizationId,
    },
  });

  const [acheivementRating, setAcheivementRating] = useState([]);
  const fetchAcheivementRating = async () => {
    try {
      const response = await get(
        `StudentEvaluation/GetAllAcheivementRating?organizationId=${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setAcheivementRating(response.acheivementRatings);
    } catch (error) {
      console.error("Error fetching subject:", error);
    }
  };
  useEffect(() => {
    fetchAcheivementRating();
  }, [triggerRerender]);

  const filteredAcheivementRating = acheivementRating.filter((rating) =>
    rating.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      width: "60px",
    },
    {
      name: "Name",
      selector: (row) => row.description,
      sortable: true,
    },
    {
      name: "Grade",
      selector: (row) => row.code,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="d-flex gap-1">
          <button
            type="button"
            className="btn p-0"
            onClick={() => handleEditClick(row.id)}
          >
            <i className="fas fa-pencil"></i>
          </button>
          <button
            type="button"
            className="btn p-0"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  const handleEditClick = async (rowId) => {
    const response = await get(
      `StudentEvaluation/GetAcheivementRatingById?id=${rowId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const acheivementRating = response.acheivementRating;

    reset({
      id: acheivementRating.id,
      description: acheivementRating.description,
      organizationId: acheivementRating.organizationId,
      code: acheivementRating.code,
      isExam: acheivementRating.IsExam,
      createdBy: acheivementRating.createdBy,
      updatedBy: localStorage.getItem("userId"),
    });
  };
  const handleDeleteClick = async (rowId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Evaluation Type?"
    );

    if (confirmDelete) {
      try {
        const response = await get(
          `StudentEvaluation/DeleteAcheivementRatingById?id=${rowId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        fetchAcheivementRating();
      } catch (error) {
        console.error("Error deleting category:", error);
      }
    }
  };
  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await post(
        "StudentEvaluation/AddUpdateAcheivementRatingAsync",
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        reset({
          id: 0,
          description: "",
          organizationId: organizationId,
          code: "",
          createdBy: localStorage.getItem("userId"),
          updatedBy: localStorage.getItem("userId"),
        });
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  const handleChangeOfInputWithLengthCheck = (fieldName) => (e) => {
    const value = e.target.value;
    setValue(fieldName, value, { shouldValidate: true });
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Acheivement Rating</h2>
      </div>
      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row g-2">
                <div className="col-md-4">
                  <label className="form-label">
                    Name<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`description`, {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("description")}
                  />
                  {errors.description && (
                    <small className="text-danger">
                      {errors.description.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Grade<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`code`, {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    onChange={handleChangeOfInputWithLengthCheck("code")}
                  />
                  {errors.code && (
                    <small className="text-danger">{errors.code.message}</small>
                  )}
                </div>
                <div className="col-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div
                className="d-flex justify-content-end"
                style={{ marginTop: 0 }}
              >
                <div className="d-flex align-items-start gap-1">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: "200px" }}
                  />
                </div>
              </div>
              <DataTable
                columns={columns}
                data={filteredAcheivementRating}
                pagination
                dense
                customStyles={customTableStyles}
                highlightOnHover={true}
                onChangePage={setCurrentPage}
                onChangeRowsPerPage={setRowsPerPage}
              />
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default StudentAchievementRating;
